import userReducer from './userReducer';
import { initState } from '../models';
import homeReducer from '../../page/home/redux/reducer';
import editpwdReducer from '../../page/editPwd/redux/reducer';
import orderNoticeReducer from '../../page/orderNotice/redux/reducer';
import orderNoticeDesReducer from '../../page/orderNoticeDes/redux/reducer';
import printDocumentReducer from '../../page/printDocument/redux/reducer';
import orderAcceptReducer from '../../page/orderAccept/redux/reducer';
import orderAcceptDesReducer from '../../page/orderAcceptDes/redux/reducer';
import orderAcceptPrintReducer from '../../page/orderAcceptPrint/redux/reducer';
import returnNoticeReducer from '../../page/returnNotice/redux/reducer';
import returnNoticeDesReducer from '../../page/returnNoticeDes/redux/reducer';
import returnNoticePrintReducer from '../../page/returnNoticePrint/redux/reducer';
import returnFromReducer from '../../page/returnFrom/redux/reducer';
import returnFromDesReducer from '../../page/returnFromDes/redux/reducer';
import returnFromPrintReducer from '../../page/returnFromPrint/redux/reducer';
import reconciliationManagementReducer from '../../page/reconciliationManagement/redux/reducer';
import entryAndCoreReducer from '../../page/entryAndCore/redux/reducer';
import accountManagementReducer from '../../page/accountManagement/redux/reducer';
import userRegisteredReducer from '../../page/userRegistered/redux/reducer';
import findPhoneNumberedReducer from '../../page/findPhoneNum/redux/reducer';

// 电子签章业务
import businessQueriesReducer from '../../page/businessQueries/redux/reducer';
import changeQueriesReducer from '../../page/changeQueries/redux/reducer';
import applyApprovalReducer from '../../page/applyApproval/redux/reducer';
import phoneChangeApprovalReducer from '../../page/phoneChangeApproval/redux/reducer';
import businessApplicationsReducer from '../../page/businessApplications/redux/reducer';
import editPhoneReducer from '../../page/editPhone/redux/reducer';
import PurchaseOrderMonitoringReducer from '../../page/PurchaseOrderMonitoring/redux/reducer';

// 对账-报表查询
import signatureStatementReducer from '../../page/signatureStatement/redux/reducer';
import unpaidAmountReducer from '../../page/unpaidAmount/redux/reducer';
import documentFreezingReducer from '../../page/documentFreezing/redux/reducer';
import vendorPaymentReducer from '../../page/vendorPayment/redux/reducer';
import invoiceManagementReducer from '../../page/invoiceManagement/redux/reducer';
import reconciliationInformationReducer from '../../page/reconciliationInformation/redux/reducer';
import expenseQueryReducer from '../../page/expenseQuery/redux/reducer';

// 预约送货 reserveDeliverData
import reserveDeliverReducer from '../../page/reserveDeliver/redux/reducer';
//bbc
import bbcNoDeliveryAreaReducer from '../../page/bbcNoDeliveryArea/redux/reducer';
import bbcOrderManageMentReducer from '../../page/bbcOrderManageMent/redux/reducer';
import bbcOrderDetailReducer from '../../page/bbcOrderDetail/redux/reducer';
import bbcPerformanceScopeReducer from '../../page/bbcPerformanceManagement/Scope/redux/reducer';
import bbcPerformanceExpressSearchReducer from '../../page/bbcPerformanceManagement/expressSearch/redux/reducer';
import bbcPerformanceHolidayReducer from '../../page/bbcPerformanceManagement/holiday/redux/reducer';
import bbcGoodsManageMentReducer from '../../page/bbcGoodsManagement/redux/reducer';
import bbcGoodsChangeReducer from '../../page/bbcGoodsChange/redux/reducer';
import bbcGoodsViewReducer from '../../page/bbcGoodsView/redux/reducer';
import yhLifeReducer from '../../page/yhLifeFreightStatement/redux/reducer';
import sortingDataQueryReducer from '../../page/sortingDataQuery/redux/reducer';
import ApplyBillingReducer from '../../page/ApplyBilling/redux/reducer';
import InvoiceRecordReducer from '../../page/InvoiceRecord/redux/reducer';
import BillingInquiryReducer from '../../page/BillingInquiry/redux/reducer';
import reconciliationCommissionReducer from '../../page/reconciliationCommission/redux/reducer';

import bbcGoodsChangeNewReducer from '../../page/bbcGoodsChangeNew/redux/reducer';
import NewbbcGoodsViewReducer from '../../page/NewbbcGoodsView/redux/reducer';
import bbcGoodsManagementNewReducer from '../../page/bbcGoodsManagementNew/redux/reducer';
import mapArrangedRouteReducer from '../../page/mapArrangedRoute/redux/reducer';

const rootReducer = (state = initState, action = {}) => {
  const user = userReducer(state, action),
    home = homeReducer(state.home, action),
    bbcGoodsChangeNew = bbcGoodsChangeNewReducer(state.bbcGoodsChangeNew, action),
    NewbbcGoodsView = NewbbcGoodsViewReducer(state.NewbbcGoodsView, action),
    bbcGoodsManagementNew = bbcGoodsManagementNewReducer(state.bbcGoodsManagementNew, action),
    editPwd = editpwdReducer(state.editPwd, action),
    orderNotice = orderNoticeReducer(state.orderNotice, action),
    orderNoticeDes = orderNoticeDesReducer(state.orderNoticeDes, action),
    printDocument = printDocumentReducer(state.printDocument, action),
    orderAccept = orderAcceptReducer(state.orderAccept, action),
    orderAcceptDes = orderAcceptDesReducer(state.orderAcceptDes, action),
    orderAcceptPrint = orderAcceptPrintReducer(state.orderAcceptPrint, action),
    returnNotice = returnNoticeReducer(state.returnNotice, action),
    returnNoticeDes = returnNoticeDesReducer(state.returnNoticeDes, action),
    returnNoticePrint = returnNoticePrintReducer(state.returnNoticePrint, action),
    returnFrom = returnFromReducer(state.returnFrom, action),
    returnFromDes = returnFromDesReducer(state.returnFromDes, action),
    returnFromPrint = returnFromPrintReducer(state.returnFromPrint, action),
    reconciliationManagement = reconciliationManagementReducer(
      state.reconciliationManagement,
      action,
    ),
    entryAndCore = entryAndCoreReducer(state.entryAndCore, action),
    accountManagement = accountManagementReducer(state.accountManagement, action),
    userRegistered = userRegisteredReducer(state.userRegistered, action),
    findPhoneNumbered = findPhoneNumberedReducer(state.findPhoneNumbered, action),
    // 电子签章业务
    businessQueries = businessQueriesReducer(state.businessQueries, action),
    changeQueries = changeQueriesReducer(state.changeQueries, action),
    applyApproval = applyApprovalReducer(state.applyApproval, action),
    phoneChangeApproval = phoneChangeApprovalReducer(state.phoneChangeApproval, action),
    businessApplications = businessApplicationsReducer(state.businessApplications, action),
    editPhone = editPhoneReducer(state.editPhone, action),
    PurchaseOrderMonitoring = PurchaseOrderMonitoringReducer(state.PurchaseOrderMonitoring, action),
    // 对账-报表查询
    signatureStatement = signatureStatementReducer(state.signatureStatement, action),
    unpaidAmount = unpaidAmountReducer(state.unpaidAmount, action),
    documentFreezing = documentFreezingReducer(state.documentFreezing, action),
    vendorPayment = vendorPaymentReducer(state.vendorPayment, action),
    reconciliationInformation = reconciliationInformationReducer(
      state.reconciliationInformation,
      action,
    ),
    invoiceManagement = invoiceManagementReducer(state.invoiceManagement, action),
    expenseQuery = expenseQueryReducer(state.expenseQuery, action),
    // 预约送货
    reserveDeliver = reserveDeliverReducer(state.reserveDeliver, action),
    //bbc
    bbcNoDeliveryArea = bbcNoDeliveryAreaReducer(state.bbcNoDeliveryArea, action),
    bbcOrderManageMent = bbcOrderManageMentReducer(state.bbcOrderManageMent, action),
    bbcOrderDetail = bbcOrderDetailReducer(state.bbcOrderDetail, action),
    bbcPerformanceScope = bbcPerformanceScopeReducer(state.bbcPerformanceScope, action),
    bbcPerformanceExpressSearch = bbcPerformanceExpressSearchReducer(
      state.bbcPerformanceExpressSearch,
      action,
    ),
    bbcPerformanceHoliday = bbcPerformanceHolidayReducer(state.bbcPerformanceHoliday, action),
    bbcGoodsManageMent = bbcGoodsManageMentReducer(state.bbcGoodsManageMent, action),
    bbcGoodsChange = bbcGoodsChangeReducer(state.bbcGoodsChange, action),
    bbcGoodsView = bbcGoodsViewReducer(state.bbcGoodsView, action),
    yhLifeStatement = yhLifeReducer(state.yhLifeStatement, action),
    ApplyBilling = ApplyBillingReducer(state.ApplyBilling, action),
    InvoiceRecord = InvoiceRecordReducer(state.InvoiceRecord, action),
    BillingInquiry = BillingInquiryReducer(state.BillingInquiry, action),
    sortingDataQueryReducerStatement = sortingDataQueryReducer(
      state.sortingDataQueryReducerStatement,
      action,
    ),
    reconciliationCommission = reconciliationCommissionReducer(
      state.reconciliationCommission,
      action,
    ),
    mapArrangedRoute = mapArrangedRouteReducer(state.mapArrangedRoute, action),
    newState = {
      previewData: user.previewData,
      userInfos: user.userInfos,
      userLoation: user.userLoation,
      bbcGoodsChangeNew,
      NewbbcGoodsView,
      bbcGoodsManagementNew,
      home,
      editPwd,
      orderNotice,
      reserveDeliver,
      orderNoticeDes,
      printDocument,
      orderAccept,
      orderAcceptDes,
      orderAcceptPrint,
      returnNotice,
      returnNoticeDes,
      returnNoticePrint,
      returnFrom,
      returnFromDes,
      returnFromPrint,
      reconciliationManagement,
      entryAndCore,
      accountManagement,
      userRegistered,
      findPhoneNumbered,

      // 电子签章业务
      businessQueries,
      changeQueries,
      applyApproval,
      phoneChangeApproval,
      businessApplications,
      editPhone,
      PurchaseOrderMonitoring,

      // 对账-报表查询
      signatureStatement,
      unpaidAmount,
      documentFreezing,
      vendorPayment,
      reconciliationInformation,
      invoiceManagement,
      expenseQuery,

      //bbc
      bbcNoDeliveryArea,
      bbcOrderManageMent,
      bbcOrderDetail,
      bbcPerformanceScope,
      bbcPerformanceExpressSearch,
      bbcPerformanceHoliday,
      bbcGoodsManageMent,
      bbcGoodsChange,
      bbcGoodsView,
      yhLifeStatement,
      sortingDataQueryReducerStatement,
      ApplyBilling,
      InvoiceRecord,
      BillingInquiry,
      reconciliationCommission,
      mapArrangedRoute,
    };
  //信息优先级处
  return newState;
};

export default rootReducer;
